import React, { useState, useRef, useEffect } from "react"
import { Upload, X, Check, AlertCircle, Loader2, Trash2, Save, AlertTriangle } from "lucide-react"
import { Button, Badge, Input, message, useCRUDController, Row, Col } from "../../ui/ot"
import StatsCard from "../../ui/stats-card"
const ChartIncreaseRate = ({
    propsDataParams = null,
    propsEnableAnimation = true,
    propsCardSize = "md",
    propsContentAlign = "center",
    propsBackgroundColor = "bg-white",
    propsLabel ="月增長率"
}) => {
    const [data, setData] = useState([
        {
            value: 0,
            label: propsLabel,
            color: "#ea570e",
            // backgroundColor: "bg-purple-100",
            animationDuration: 2000,
            animationDelay: 0,
        }
    ])
    const [loading, setLoading] = useState(false)
    const dataController = useCRUDController({ apiRoute: "/koha/report/item/increase_rate" })
    const getData = () => {
        setLoading(true)
        dataController.getData({
            ...propsDataParams
        }).then((response) => {
            setLoading(false)
            if (!!response) {
                setData([{
                    value: response?.growth_rate,
                    label: propsLabel,
                    color: "#ea570e",
                    // backgroundColor: "bg-purple-100",
                    animationDuration: 2000,
                    animationDelay: 0,
                }])
            }
        })
    }
    useEffect(() => {
        getData()
    }, [propsDataParams])


    return (<Row>
        <Col span={24}>
            <StatsCard
                layout="horizontal"
                stats={data}
                enableAnimation={propsEnableAnimation}
                isLoading={loading}
                loadingDuration={1500}
                size={propsCardSize}
                contentAlign={propsContentAlign}
                backgroundColor={propsBackgroundColor}
                connection={'separated'}
                columnsPerRow={1}
            />
        </Col>
    </Row>)
}
export { ChartIncreaseRate }